<template>
  <div class="w1200" style="padding-top: 15px">
    <div class="w240 fl">
      <div class="bg1 lh46 nav" style="padding:0">
        <ul>
          <li
            @click="changeRouter(n.url)"
            :class="$route.name == n.url ? 'on' : ''"
            v-for="n in nav"
            :key="n.url"
          >
            {{ n.name }}
          </li>
        </ul>
      </div>
    </div>
    <div class="w940 fr">
      <router-view></router-view>
    </div>
    <div class="cl"></div>
  </div>
</template>

<script>
import link from "../mixins/link";
export default {
  data() {
    return {
    //   nav: [
    //     { name: "角色管理", url: "manageRole" },
    //     { name: "资源类别管理", url: "manageCategory" },
    //     { name: "宣传图管理", url: "manageBanner" },
    //     { name: "文印管理", url: "managePrinting" },
    //     { name: "审核管理", url: "manageExamine" },
    //   ],
    };
  },
  props: { nav: { type: Array } },
  mixins: [link],
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/side.vue